// cross-origin iframe makes cloneNode produce an invisible ghost
import styles from './createTilePreviewGhost.module.scss'

export const createAiArtifactDragGhost = (
  title: string,
  width: number,
  height: number
): HTMLElement => {
  const el = document.createElement('div')
  el.className = styles.ghost
  el.style.width = `${width}px`
  el.style.height = `${height}px`

  const thumb = document.createElement('div')
  thumb.className = styles.thumb
  thumb.textContent = (title.trim().charAt(0) || '◆').toUpperCase()

  const name = document.createElement('div')
  name.className = styles.name
  name.textContent = title

  el.append(thumb, name)
  document.body.appendChild(el)
  return el
}

export const createAiArtifactNativeDragImage = (
  title: string,
  width: number,
  height: number,
  position: { left: number; top: number }
): HTMLCanvasElement => {
  const scale = window.devicePixelRatio || 1
  const canvas = document.createElement('canvas')
  canvas.width = width * scale
  canvas.height = height * scale
  canvas.style.position = 'fixed'
  canvas.style.left = `${position.left}px`
  canvas.style.top = `${position.top}px`
  canvas.style.width = `${width}px`
  canvas.style.height = `${height}px`
  canvas.style.zIndex = '2147483647'
  canvas.style.pointerEvents = 'none'

  const context = canvas.getContext('2d')
  if (context) {
    context.scale(scale, scale)
    context.beginPath()
    context.roundRect(0.5, 0.5, width - 1, height - 1, 16)
    context.fillStyle = 'rgba(255, 255, 255, 0.95)'
    context.fill()
    context.strokeStyle = '#ededed'
    context.stroke()

    context.fillStyle = '#2b2b2b'
    context.font = '600 13px sans-serif'
    context.textAlign = 'center'
    context.textBaseline = 'middle'
    context.fillText(title, width / 2, height / 2, width - 32)
  }

  // WebKit only captures custom drag images that participate in a painted
  // frame. The caller keeps this in the viewport through one paint.
  document.body.appendChild(canvas)
  return canvas
}
